import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReport = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.00004 1.66675C4.08337 1.66675 3.34171 2.41675 3.34171 3.33341L3.33337 16.6667C3.33337 17.5834 4.07504 18.3334 4.99171 18.3334H15C15.9167 18.3334 16.6667 17.5834 16.6667 16.6667V7.35842C16.6667 6.91675 16.4917 6.49175 16.175 6.18341L12.15 2.15841C11.8417 1.84175 11.4167 1.66675 10.975 1.66675H5.00004ZM10.8334 6.66675V2.91675L15.4167 7.50008H11.6667C11.2084 7.50008 10.8334 7.12508 10.8334 6.66675Z" })
});
export default SvgReport;
